import React from 'react';
import PropTypes from 'prop-types';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import path from '../../helpers/path';
import './DashboardPromoCarousel.css';

const base = getBEMClasses('dashboard-promo-carousel');

const DASH_COVER = path('/local/landing-page/images/login-modalbackground.png');

const getDefaultSlides = t => [
  {
    id: 'swap',
    cover: DASH_COVER,
    title: t('Fast, simple swaps'),
    body: t('Low fees, one-click flow, and tight spreads on popular pairs.')
  },
  {
    id: 'trade',
    cover: DASH_COVER,
    title: t('Trade the markets'),
    body: t('Charts, deep liquidity, and professional tools when you use Pro view.')
  },
  {
    id: 'secure',
    cover: DASH_COVER,
    title: t('Your assets, organized'),
    body: t('Wallets, activity, and transfers in one secure hub.')
  }
];

class DashboardPromoCarousel extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    slides: PropTypes.array
  };

  static defaultProps = {
    slides: null
  };

  state = { index: 0 };

  go = nextIndex => {
    const slides = this.getSlides();
    if (!slides.length) return;
    const i = ((nextIndex % slides.length) + slides.length) % slides.length;
    this.setState({ index: i });
  };

  getSlides = () => this.props.slides || getDefaultSlides(this.props.t);

  next = () => this.go(this.state.index + 1);
  prev = () => this.go(this.state.index - 1);

  render() {
    const { t } = this.props;
    const { index } = this.state;
    const slides = this.getSlides();
    const current = slides[index];

    if (!current) {
      return null;
    }

    return (
      <div className={base()} aria-roledescription="carousel">
        <div className={base('header')}>
          <span className={base('title')}>{t('Highlights')}</span>
          <div className={base('arrows')}>
            <button
              type="button"
              className={base('arrow')}
              onClick={this.prev}
              aria-label={t('Previous slide')}>
              ‹
            </button>
            <button
              type="button"
              className={base('arrow')}
              onClick={this.next}
              aria-label={t('Next slide')}>
              ›
            </button>
          </div>
        </div>
        <div
          className={base('frame', { cover: Boolean(current.cover) })}
          style={
            current.cover
              ? { backgroundImage: `url(${current.cover})` }
              : undefined
          }>
          <article
            className={base('slide', { cover: Boolean(current.cover) })}
            key={current.id}>
            {current.cover ? <div className={base('cover-scrim')} aria-hidden /> : null}
            {current.art && !current.cover ? (
              <div
                className={base('art-wrap')}
                style={current.bg ? { background: current.bg } : undefined}>
                <img
                  className={base('art')}
                  src={current.art}
                  alt=""
                />
              </div>
            ) : null}
            <div
              className={base('copy', { overlay: Boolean(current.cover) })}>
              <h3 className={base('slide-title')}>{current.title}</h3>
              {current.body ? <p className={base('body')}>{current.body}</p> : null}
            </div>
          </article>
        </div>
        <ul className={base('dots')}>
          {slides.map((s, i) => (
            <li key={s.id}>
              <button
                type="button"
                className={base('dot', { active: i === index })}
                onClick={() => this.go(i)}
                aria-label={`${t('Slide')} ${i + 1}`}
                aria-current={i === index ? 'true' : 'false'}
              />
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default DashboardPromoCarousel;
